import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-275f93b5"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "这里是展示技术博客的地方")], -1));

const _hoisted_2 = {
  class: "blogClass"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "博客分类", -1));

const _hoisted_4 = {
  href: "#"
};
const _hoisted_5 = {
  class: "blogList"
};
const _hoisted_6 = ["id", "onClick"];
const _hoisted_7 = {
  class: "blogItemTitleBox"
};
const _hoisted_8 = {
  class: "classText"
};
const _hoisted_9 = {
  class: "blogItemTitle"
};
const _hoisted_10 = {
  class: "blogItemCreated_at"
};
import { onMounted, ref } from "vue";
import { blogClassAll, getBlogList } from "@/api/blog.js";
import { useRouter } from "vue-router";
import MdEditor from "md-editor-v3";
import "md-editor-v3/lib/style.css";
export default {
  __name: 'blog',

  setup(__props) {
    const $router = useRouter(); //blog分类

    const blogClassList = ref([{
      id: 1,
      value: "张三"
    }, {
      id: 2,
      value: "张4"
    }, {
      id: 3,
      value: "5sad啊啥的"
    }]); // blogDetails
    //blog列表

    const blogList = ref([{
      id: 1,
      class_text: "编程入门",
      title: "编程知识介绍",
      content: "什么是程序员，一个程序员应该做什么，首先，应该对编程感兴趣",
      created_at: "2022-12-7 8:0:0"
    }, {
      id: 2,
      class_text: "杂谈",
      title: "无神论者二三论",
      content: "网上经常有人问：为什么无神论者那么坚定？其实，每个宗教徒都是从无神论者转变的",
      created_at: "2022-12-7 8:0:0"
    }, {
      id: 3,
      class_text: "反诈",
      title: "理财得避开哪些坑",
      content: "这里会收录一些常见的骗局，让大家擦亮眼睛，扩大眼界",
      created_at: "2022-12-7 8:0:0"
    }, {
      id: 4,
      class_text: "编程入门",
      title: "编程知识介绍",
      content: "怎么成为一名优秀的程序员",
      created_at: "2022-12-7 8:0:0"
    }]);

    const enterBlog = id => {
      console.log(id);
      console.log('点击了进入详情', id); // $router.push('/home',params);

      $router.push({
        path: '/blog/details',
        query: {
          id: id
        }
      });
    };

    onMounted(() => {
      console.log("挂载完成");
      document.title = "博客杂记";
      const postData = {
        time: new Date()
      }; //请求服务器blog分类

      blogClassAll().then(res => {
        console.log(res);
        blogClassList.value = res.data.data.list; //获取最近发布的5条blog

        return getBlogList(postData);
      }).then(res => {
        console.log('获取最近发布的5条blog', res);
        blogList.value = res.data.data.map(val => {
          console.log(val);
          val.content = val.content.replace(/####/g, '#####').replace(/###/g, '####').replace(/##/g, '###').replace(/#/g, '##');
          return val;
        });
      }).catch(err => {
        console.log("发生错误了", err);
      }); // blogClassAll()
      //   .then((res) => {
      //     console.log(res);
      //     blogClassList.value = res.data.data.list;
      //   })
      //   .catch((err) => {
      //     console.log("发生错误了", err);
      //   });
      // const postData = {
      //   time: new Date()
      // }
      // //获取最近发布的5条blog
      // getBlogList(postData).then((res)=>{
      //   console.log('获取最近发布的5条blog',res)
      //   blogList.value = res.data.data
      // })
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogClassList.value, classItem => {
        return _openBlock(), _createElementBlock("li", {
          key: classItem.id
        }, [_createElementVNode("a", _hoisted_4, _toDisplayString(classItem.value), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogList.value, blogItem => {
        return _openBlock(), _createElementBlock("div", {
          class: "blogItem",
          key: blogItem.id,
          id: blogItem.id,
          onClick: $event => enterBlog(blogItem.id)
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, _toDisplayString(blogItem.class_text), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(blogItem.title), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(blogItem.created_at), 1)]), _createVNode(_unref(MdEditor), {
          class: "blogItemContent",
          modelValue: blogItem.content,
          "onUpdate:modelValue": $event => blogItem.content = $event,
          "preview-only": true
        }, null, 8, ["modelValue", "onUpdate:modelValue"])], 8, _hoisted_6);
      }), 128))])], 64);
    };
  }

};